<template>
  <div class="pie-chart-bag">
    <div class="pie-chart-left">
      <div class="pie-chart-title">
        <img :src="base_url + '/images/icons/13.png'" alt="">
        <span>各線路耗電比例</span>
      </div>
      <div id="pieLegend">
        <div class="legend-item" v-for="item, index in legend_items" :key="index">
          <div class="item-icon" :style="`background-color: ${RGBformat(scaleColors[index])};`"></div>
          <div class="item-alias">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="pie-chart-right">
      <div id="pieChart">
        <div id="totalValue">
          <p>{{ calcTotalCost }} kWh</p>
          累積耗電量
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosMixins } from '@components/mixins/axiosErrorMessage';
import { chartMixin } from '../mixins/chartMixin';

export default {
  mixins: [axiosMixins, chartMixin],
  data() {
    return {
      base_url: base_url,
      carbon_coe: '',
      calcTotalCost: 0,
      legend_items: [],
    }
  },
  mounted() {
    console.log('--pie-chart-- mounted');
    this.initChart();
  },
  beforeDestroy() {
    console.log('--pie-chart-- beforeDestroy');
  },
  computed: {
    meter() {
      return this.$store.getters.selectedMeter;
    },
    scaleColors() {
      let scaleColors = this.$store.getters.scaleColors;
      return scaleColors.slice(1);
    },
  },
  watch: {
    meter() {
      this.initChart();
    },
    deep: true
  },
  methods: {
    initChart() {
      console.log('--pie-chart-- init pie chart');
      this.destroyChart();
      this.renderChart();
    },
    destroyChart() {
      const old_chart_legend = this.$el.querySelector("#legend-svg");
      const old_chart_slices = this.$el.querySelector("#pie-svg");
      if (old_chart_legend) { old_chart_legend.remove(); }
      if (old_chart_slices) { old_chart_slices.remove(); }
    },
    devMath(int_result) {
      if (int_result < 1) {
        int_result = int_result * 100 + 2;
      }
      return int_result * 14;
    },
    // 總電量外，其餘電路耗電比例
    renderChart() {
      if (!this.meter.bx_circuits) {
        return
      }
      let circuits = this.meter.bx_circuits;
      let data = [];
      let count = 0;

      const circuit_keys = Object.keys(circuits);
      this.legend_items = []
      for (let i = 0; i < circuit_keys.length; i++) {
        let cumulative_data = [];
        cumulative_data = circuits[i].cumulative_data.filter(value => {
          return value.cumulative_ep !== "";
        });
        if (cumulative_data.length > 0 && i !== 0) {
          let cumulative_ep = cumulative_data[cumulative_data.length - 1].cumulative_ep;
          this.legend_items.push(circuits[i].alias);
          data[count] = {
            alias: circuits[i].alias,
            cumulative_ep: Math.abs(cumulative_ep),
          };
          count++
        } else if (i === 0) {
          this.calcTotalCost = cumulative_data[cumulative_data.length - 1].cumulative_ep;
        }
      }

      const height = parseInt(d3.select('#pieChart').style("height"), 10);
      let colors = this.scaleColors.map(d => this.RGBformat(d));
      let svg = d3.select("#pieChart").attr("class", "box");
      const chart_params = {
        data: data,
        width: height,
        height: height,
        radius: height / 2,
        legendItemSize: 12,
        legendSpacing: 15,
        scaleColors: colors,
        svg: svg,
        config: {
          padding: { top: height / 30, left: height / 30, right: height / 30, bottom: height / 30 },
          margin: { top: 0, left: 0, bottom: 0, right: 0 },
          textColor: "black",
          innerRadius: height / 2.3,
          outerRadius: height / 2,
          textOffsetH: 10,
          lineColor: "black",
          animateDuration: 0,
        }
      }

      this.pie_chart_params = chart_params;
      this.renderPieChart();
    },
    // 耗電量總計
    createTotalValue(data) {
      const showValue = Math.max(...data.map(item => {
        return item.cumulative_ep;
      }).filter(d => d))

      // 依渲染圖表大小，設定總耗電量字型大小
      const height = parseInt(d3.select('#energyChart').style("height"), 10);
      this.$el.querySelector("#totalValue").style.fontSize = height / 600 + "rem"
      this.$el.querySelector("#totalValue").querySelector("p").innerText = Math.round(showValue * 10) / 10 + " kWh";
    },
  }
}
</script>

<style>
#legend-svg {
  width: 100%;
  height: 100%;
  font-size: .8rem;
}

.pie-chart-bag {
  display: flex;
  justify-content: space-between;
}

.pie-chart-bag .pie-chart-left {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 60%;
}

.pie-chart-bag .pie-chart-left .pie-chart-title {
  height: 20%;
  min-height: 2.8rem;
  padding: 6% 0 0 6%;
}

.pie-chart-bag .pie-chart-left .pie-chart-title>img {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: .5rem;
}

.pie-chart-bag .pie-chart-left #pieLegend {
  height: calc(100% - 20%);
  padding: 2% 0 0 8%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  font-size: .7rem;
}

.pie-chart-bag .pie-chart-left #pieLegend .legend-item {
  min-width: 50%;
  display: flex;
  align-items: center;
}

.pie-chart-bag .pie-chart-left #pieLegend .legend-item .item-icon {
  width: .5rem;
  height: .5rem;
  border-radius: 50%;
  margin-right: .5rem;
  margin-left: .5rem;
}

.pie-chart-bag .pie-chart-right {
  width: 50%;
}

.pie-chart-bag .pie-chart-right #pieChart {
  height: 100%;
  float: right;
  padding-right: 2%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pie-chart-bag .pie-chart-right #pieChart #totalValue {
  text-align: center;
  position: absolute;
  color: var(--bx-blur);
}

.pie-chart-bag .pie-chart-right #pieChart #totalValue>p {
  font-size: 1.5rem;
  font-weight: bolder;
  color: var(--bx-dark-blue);
}

@media (min-width: 1300px) {
  .pie-chart-bag .pie-chart-left #pieLegend {
    font-size: .9rem;
  }

  .pie-chart-bag .pie-chart-left #pieLegend .legend-item {
    margin-bottom: 2%;
  }

  .pie-chart-bag .pie-chart-right #pieChart #totalValue>p {
    font-size: 2rem;
  }
}

@media (max-width: 1150px) {
  .pie-chart-bag .pie-chart-right #pieChart #totalValue>p {
    font-size: 1.3rem;
  }

  .pie-chart-bag .pie-chart-right #pieChart #totalValue {
    font-size: .8rem;
  }
}
</style>
